import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { Tooltip, Typography } from "antd"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faClone, faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons"
import { getMaskedString, getTruncatedSecretKey } from "@/utils/strings"

interface IDisplaySecret {
  secret: string
  length?: number
  type?: "mask" | "truncate"
}

const DisplaySecret: React.FC<IDisplaySecret> = ({ secret, length, type = "mask" }) => {
  const { t } = useTranslation()
  const [isHidden, setIsHidden] = useState(true)
  const { Text } = Typography

  const hiddenSecretString =
    type === "mask" ? getMaskedString(length || 30) : getTruncatedSecretKey(secret)

  return (
    <p className="flex-shrink-0 my-auto whitespace-wrap">
      <div className="flex items-center">
        <Tooltip
          title={isHidden ? t("developers.Webhooks.revealKey") : t("developers.Webhooks.hideKey")}
        >
          <FontAwesomeIcon
            icon={isHidden ? faEye : faEyeSlash}
            className="mr-2 text-gray-600 cursor-pointer w-[18px] select-none"
            onClick={() => setIsHidden(!isHidden)}
          />
        </Tooltip>
        <p className="break-all">
          {isHidden ? (
            hiddenSecretString
          ) : (
            <Text
              copyable={{
                icon: (
                  <FontAwesomeIcon
                    className="text-gray-500 break-all text-md cursor-pointer"
                    icon={faClone}
                  />
                ),
              }}
            >
              {secret}
            </Text>
          )}
        </p>
      </div>
    </p>
  )
}

export default DisplaySecret
